import theme from './theme'
import components from './components'

const themes = {
  components,
  theme
}

export default themes
